module.exports = __webpack_public_path__ + "static/media/acesso-empresa.1511a310.svg";